import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Season } from './../../models';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
@Component({
  selector: 'app-e-novel-pricing-form',
  templateUrl: './e-novel-pricing-form.component.html',
  styleUrls: ['./e-novel-pricing-form.component.css']
})
export class ENovelPricingFormComponent implements OnInit {

  novelpricingForm:FormGroup;
  showprice: any = false;
  id: any;
  price: any;
  loading: boolean = false;
  load: boolean = false;
  constructor(private form:FormBuilder,private afs: AngularFirestore,private router: Router,private route: ActivatedRoute) { }

  
  ngOnInit() {
    this.novelpricingForm = this.form.group({
      seasonprice: ['', [Validators.required]],
      seasonvalidity: ['', [Validators.required]],
      episodeprice: ['', [Validators.required]],
      episodevalidity: ['', [Validators.required]],
      status: ['', [Validators.required]],
      IsAllowPointsPurchase:["false",[Validators.required]],
    });
    if (this.route.firstChild) {
      this.route.firstChild.params.subscribe(params => {
        this.id = params['id'];
        if (this.id) {
          const seasondoc: AngularFirestoreDocument<Season> = this.afs.doc('Enovelseason/' + this.id)
          seasondoc.valueChanges().subscribe(singlechapter => {
            console.log(singlechapter);
            this.price = singlechapter.pricing_type;
            if (this.price != 'Free') {
              const pricedetails = singlechapter.prices;
              this.novelpricingForm.get('seasonprice').setValue(pricedetails['seasonprice']);
              this.novelpricingForm.get('seasonvalidity').setValue(pricedetails['seasonvalidity']);
              this.novelpricingForm.get('episodeprice').setValue(pricedetails['episodeprice']);
              this.novelpricingForm.get('episodevalidity').setValue(pricedetails['episodevalidity']);
              this.novelpricingForm.get('IsAllowPointsPurchase').setValue(String(pricedetails['IsAllowPointsPurchase']));
            }
            this.showprice = true;
          });
        }
      });
    }

  }

  addpricing(value, valid) {
    try {
      if (value.status != 'Free') {
        if (valid) {
          this.loading=true;
          console.log(value);
          this.afs.doc('Enovelseason/' + this.id).update({ pricing_type: value.status, prices: value,IsAllowPointsPurchase:JSON.parse(value.IsAllowPointsPurchase)});
          this.router.navigate(['/novel-seasons']);
        } else {
          this.loading=false;
          this.load=true;
          console.log('error');
        }
      } else {
        this.afs.doc('Enovelseason/' + this.id).update({ pricing_type: 'Free' });
        this.router.navigate(['/novel-seasons']);
      }
    } catch (error) {
      console.log(error);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/E-novels/e-novel-pricing-form/e-novel-pricing-form.component.ts